"use client";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";
import { User } from "lucide-react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useAuthStore } from "@/store/AuthStore";

const UserMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const authStore = useAuthStore();
  const user = useAuthStore((state) => state.user);

  const logout = () => {
    authStore.logout();
    navigate("/login");
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button className="p-2 sm:p-3 hover:bg-gray-50 transition-colors duration-200 rounded-md outline-none">
          <User size={18} className="text-white font-medium md:text-gray-700" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2 bg-white border border-gray-200 rounded-lg shadow-xl z-50">
        {user ? (
          <>
            {/* Profile Header */}
            <div className="px-3 py-3 border-b border-gray-100">
              <p className="text-sm font-semibold text-gray-900">{user.name}</p>
              <p className="text-xs text-gray-500 truncate mt-1">
                {user.email}
              </p>
            </div>

            <div className="py-1">
              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate("/profile");
                }}
                className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded-md cursor-pointer transition-colors duration-200"
              >
                {t("myAccount")}
              </button>
              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate("/orders");
                }}
                className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded-md cursor-pointer transition-colors duration-200"
              >
                {t("orders")}
              </button>
              <button
                onClick={() => {
                  setIsOpen(false);
                  logout();
                }}
                className="w-full text-left px-3 py-2 text-sm hover:bg-red-50 text-red-600 rounded-md cursor-pointer transition-colors duration-200"
              >
                {t("logout")}
              </button>
            </div>
          </>
        ) : (
          <div className="py-1">
            <Link
              to="/login"
              onClick={() => setIsOpen(false)}
              className="block w-full px-3 py-2 text-sm hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              {t("login")}
            </Link>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default UserMenu;
